import { VWO_HOMEPAGE_EXPERIMENT } from "../../config/vwoKeys";

export default {
  namespaced: true,
  state: {
    vwoExperiments: { [VWO_HOMEPAGE_EXPERIMENT]: "" },
  },
  getters: {
    getVwoExperiments: (state) => {
      return state.vwoExperiments;
    },
  },
  mutations: {
    updateVwoExperiments(state, payload) {
      state.vwoExperiments = payload;
    },
  },
  actions: {},
};
